import React, { Component } from 'react';
import axios from 'axios';

export class Chart extends Component {

  constructor(props) {
    super(props);

    this.state = {
      chartData: []
    }

    this.getChartData();
  }

  async getChartData() {
    var response = axios.get('/getchartdata');
    try {
      var resultData = (await response).data;
      this.setState({ chartData: resultData });
    } 
    catch {
      this.setState({ chartData: [] });
    }
  }

  getCount(number) {
    for(var i=0; i<this.state.chartData.length; i++) {
      if(this.state.chartData[i].startsWith(number + " ")) {
        return this.state.chartData[i].split(" ")[1];
      }
    }
    return "0";
  }

  render() {
    return (
      <div>
        <h2>참가자</h2>
        <br/>
        <div style={{textAlign: 'center'}}></div>
        <table width="100%" style={{textAlign: 'center'}}><tbody>
          <tr>
            <td width="120px"></td>
            <td width="80px">일요일</td>
            <td width="80px">월요일</td>
            <td width="80px">화요일</td>
            <td width="80px">수요일</td>
            <td width="80px">목요일</td>
            <td width="80px">금요일</td>
            <td width="80px">토요일</td>
          </tr>
          <tr>
            <td>하루 금식</td>
            <td><a href="/participant/1">{this.getCount("1")}</a></td>
            <td><a href="/participant/2">{this.getCount("2")}</a></td>
            <td><a href="/participant/3">{this.getCount("3")}</a></td>
            <td><a href="/participant/4">{this.getCount("4")}</a></td>
            <td><a href="/participant/5">{this.getCount("5")}</a></td>
            <td><a href="/participant/6">{this.getCount("6")}</a></td>
            <td><a href="/participant/7">{this.getCount("7")}</a></td>
          </tr>
        </tbody></table>
        <br />
        <br />
        <table width="100%" style={{textAlign: 'center'}}><tbody>
          <tr>
            <td width="120px"></td>
            <td width="80px">일요일</td>
            <td width="80px">월요일</td>
            <td width="80px">화요일</td>
            <td width="80px">수요일</td>
            <td width="80px">목요일</td>
            <td width="80px">금요일</td>
            <td width="80px">토요일</td>
          </tr>
          <tr>
            <td>아침 금식</td>
            <td><a href="/participant/11">{this.getCount("11")}</a></td>
            <td><a href="/participant/21">{this.getCount("21")}</a></td>
            <td><a href="/participant/31">{this.getCount("31")}</a></td>
            <td><a href="/participant/41">{this.getCount("41")}</a></td>
            <td><a href="/participant/51">{this.getCount("51")}</a></td>
            <td><a href="/participant/61">{this.getCount("61")}</a></td>
            <td><a href="/participant/71">{this.getCount("71")}</a></td>
          </tr>
          <tr>
            <td>점심 금식</td>
            <td><a href="/participant/12">{this.getCount("12")}</a></td>
            <td><a href="/participant/22">{this.getCount("22")}</a></td>
            <td><a href="/participant/32">{this.getCount("32")}</a></td>
            <td><a href="/participant/42">{this.getCount("42")}</a></td>
            <td><a href="/participant/52">{this.getCount("52")}</a></td>
            <td><a href="/participant/62">{this.getCount("62")}</a></td>
            <td><a href="/participant/72">{this.getCount("72")}</a></td>
          </tr>
          <tr>
            <td>저녁 금식</td>
            <td><a href="/participant/13">{this.getCount("13")}</a></td>
            <td><a href="/participant/23">{this.getCount("23")}</a></td>
            <td><a href="/participant/33">{this.getCount("33")}</a></td>
            <td><a href="/participant/43">{this.getCount("43")}</a></td>
            <td><a href="/participant/53">{this.getCount("53")}</a></td>
            <td><a href="/participant/63">{this.getCount("63")}</a></td>
            <td><a href="/participant/73">{this.getCount("73")}</a></td>
          </tr>
        </tbody></table>
        <br />
        <br />
        <br />
        <table width="100%"><tbody><tr>
          <td width="30%" />
          <td style={{textAlign: 'center'}}><button className="btn btn-primary" onClick={() => this.props.history.push("/")}>홈 페이지</button></td>
          <td style={{textAlign: 'center'}}><button className="btn btn-primary" onClick={() => this.props.history.push("/signup")}>금식 기도 참여</button></td>
          <td width="30%" />
        </tr></tbody></table>
      </div>
    );
  }
}
